// extracted by mini-css-extract-plugin
export var grid = "_2-5";
export var layout = "_2-0";
export var leftColumn = "_2-1";
export var leftInner = "_2-2";
export var rightColumn = "_2-3";
export var rightInner = "_2-4";